import { LitElement, html, svg } from 'lit';

export class IconSearch32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Forstørrelsesglass</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.81 24.204c6.143-2.61 9.006-9.706 6.395-15.848C21.595 2.214 14.5-.649 8.358 1.962c-6.142 2.61-9.006 9.705-6.395 15.847 2.61 6.142 9.705 9.005 15.848 6.395ZM21.628 21.627 31 31"></path></svg>`; }
}
if (!customElements.get('f-icon-search32', IconSearch32)) {
  customElements.define('f-icon-search32', IconSearch32);
}